import React, { Suspense } from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';
import CostAccountingContainer from '../containers/CostAccountingContainer/CostAccountingContainer';
import {
    costAccounting,
    costAccountingAudit,
    costAccountingDistributionPlans,
    costAccountingMappings,
    costAccountingOverrides,
    costAccountingPeriods,
    costAccountingProfitability,
    costAccountingQueue,
} from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';

const CostAccountingQueuePage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingQueuePage'));
const CostAccountingOverridesPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingOverridesPage'));
const CostAccountingPeriodsPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingPeriodsPage'));
const CostAccountingAuditPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingAuditPage'));
const CostAccountingProfitabilityPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingProfitabilityPage'));
const CostAccountingMappingsPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingMappingsPage.jsx'));
const CostAccountingDistributionPlansPage = React.lazy(() => import('../pages/CostAccountingPages/CostAccountingDistributionPlansPage.jsx'));

const CostAccountingRoutes = props => (
    <CostAccountingContainer history={props.history}>
        <Suspense fallback={<PageLoader />}>
            <Route path={costAccounting} exact component={CostAccountingQueuePage} />
            <Route path={costAccountingQueue} exact component={CostAccountingQueuePage} />
            <Route path={costAccountingMappings} exact component={CostAccountingMappingsPage} />
            <Route path={costAccountingDistributionPlans} exact component={CostAccountingDistributionPlansPage} />
            <Route path={costAccountingOverrides} exact component={CostAccountingOverridesPage} />
            <Route path={costAccountingPeriods} exact component={CostAccountingPeriodsPage} />
            <Route path={costAccountingAudit} exact component={CostAccountingAuditPage} />
            <Route path={costAccountingProfitability} exact component={CostAccountingProfitabilityPage} />
        </Suspense>
    </CostAccountingContainer>
);

CostAccountingRoutes.propTypes = {
    history: PropTypes.object.isRequired,
};

export default CostAccountingRoutes;
